import React, { useState, useEffect } from "react";
import { Form, Radio } from "antd";
import Typing from "../Typing/Typing";
import * as Utils from "../../services/utils";
import CmpsAnimation from "../CmpsAnimation/CmpsAnimation";
import Timestamp from "../../components/Timestamp/Timestamp";
import CmpsMsgStatus from "../CmpsMsgStatus/CmpsMsgStatus";

function CmpsConsentSecond({ onComplete, onScroll, form, onShowInput }) {
    const [typing, setTyping] = useState(true);
    const [msg, setMsg] = useState(false);
    const [msgChoose, setMsgChoose] = useState(true);

    let list = [
        { label: "Acconsento", value: true },
        { label: "Non acconsento", value: false },
    ];

    const onChange = (e) => {
        setMsg(form.getFieldValue("secondo_consenso").label);
        setMsgChoose(false);
        onComplete("step14");
    };

    useEffect(() => {
        Utils.eventsDataLayer("customPageview", "/chatbot-fissa-appuntamento/privacy-step-2");
        onShowInput(false);
        const timer = setTimeout(() => {
            setTyping(false);
            onScroll();
        }, 2200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section id="cmps-consent2">
            {typing && <Typing wait={1200} />}
            {!typing && (
                <div className="messages messages--receiver">
                    <div className="message">
                        <CmpsAnimation wait={300} last={!msgChoose}>
                            <span className="bubble">
                                {/* Dichiari di aver scaricato e letto<br /> le INFORMATIVE, che i tuoi dati<br /> personali siano trattati da<br /> Compass, per la finalità di cui<br /> alla 
              lettera e), ovvero per<br /> svolgere attività di profilazione<br /> consistenti nella individuazione<br /> di preferenze, gusti, abitudini,<br /> necessità 
              e scelte di consumo e<br /> nella definizione del profilo<br /> dell’interessato, in modo da<br /> migliorare i prodotti o servizi<br /> offerti e soddisfare 
              le esigenze<br /> dell’interessato medesimo,<br /> nonché per effettuare, previo lo<br /> specifico consenso,<br /> comunicazioni a carattere<br /> promozionale, 
              pubblicitario o<br /> commerciale personalizzate,<br /> con i mezzi indicati<br /> nell’informativa. */}
                                <b>Consenso al trattamento dei dati per attività di profilazione funzionali all'invio di comunicazioni promozionali finalizzate (lettera e)</b>
                                <br />
                                <br />
                                Preso atto dell'Informativa resa da Compass Banca S.p.A. ai sensi degli artt. 13 e 14 del Regolamento e della normativa nazionale vigente in materia di protezione dei
                                dati personali e del Codice di condotta per i sistemi informativi gestiti da soggetti privati in tema di crediti al consumo, affidabilità e puntualità nei pagamenti,
                                che i tuoi dati personali siano trattati da Compass, per la finalità di cui alla lettera e), ovvero per svolgere attività di profilazione consistenti nella
                                individuazione di preferenze, gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell'interessato, in modo da migliorare i prodotti o
                                servizi offerti e soddisfare le esigenze dell'interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni a carattere promozionale,
                                pubblicitario o commerciale personalizzate, con i mezzi indicati nell'informativa.
                            </span>
                        </CmpsAnimation>
                        {msgChoose && (
                            <CmpsAnimation wait={600} last={true}>
                                <span className="bubble">Seleziona la tua scelta</span>
                            </CmpsAnimation>
                        )}
                        <CmpsAnimation wait={900}>
                            {!msg && (
                                <Form.Item className={`cmps_radio_button cmps_radio_button__consent`} name="secondo_consenso">
                                    <Radio.Group onChange={onChange}>
                                        {list.map((item, index) => (
                                            <Radio.Button key={index} value={item}>
                                                {item.label}
                                            </Radio.Button>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            )}
                            <div className="info">
                                <span className="time">
                                    <Timestamp />
                                </span>
                            </div>
                        </CmpsAnimation>
                    </div>
                </div>
            )}
            {msg && (
                <div className="messages messages--sender">
                    <CmpsAnimation wait={300}>
                        <div className="message">
                            <span className="bubble">{msg}</span>
                        </div>
                        <div className="info">
                            <span className="time">
                                <Timestamp />
                            </span>
                            <CmpsMsgStatus />
                        </div>
                    </CmpsAnimation>
                </div>
            )}
        </section>
    );
}

export default CmpsConsentSecond;
